import { Outlet } from "react-router-dom";
import SettingsHeader from "./settings-header";
import '../../../styles/Auth/settings.css';
const SettingsPage = () => {
    return (
        <div className="settings-layout">
            <div className="settings-content">
                <main className="settings-main">
                    <SettingsHeader />
                </main>
                <div className="settings-body">
                    <Outlet />
                </div>

            </div >
        </div >
    );
}

export default SettingsPage;